mutation AccessGroupDelete($input: AccessGroupDeleteInput!) {
  accessGroupDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
